import React, {useEffect, useMemo, useState} from "react";
import Table from "components/molecules/Table";
import {ManageBranchesWrapper} from "components/atoms/Store/ManageStore/ManageStore.styles";
import {FaRegEdit} from "react-icons/fa";
import {MdDelete} from "react-icons/md";
import DeleteModal from "components/atoms/DeleteModal/Index";
import AddNewBranch from "components/atoms/Store/ManageStore/AddNewBranch/Index";
import TableLayout from "components/molecules/TableLayout";
import ModalContainer from "components/molecules/ModalContainer";
import manageStores from "services/manageSores";
import Toast from "components/molecules/Toast";
import {useSelector} from "react-redux";
import {useAuthContext} from "Context/authContext";
import {IoEyeOutline} from "react-icons/io5";
import StorePreview from "./StorePreview";

const ManageBranches = ({searchQuery, setSearchQuery, onStoreUpdated, stores_data, stores_loading}) => {
    const {hasPermission} = useAuthContext("hasPermission");

    const business = useSelector(state => state.business.businessId);
    // const [searchQuery, setSearchQuery] = useState({
    //     page: 1,
    //     itemsPerPage: 10,
    //     searchText: "",
    //     businessId: business,
    // });
    // Note: stores_data and stores_loading are now passed as props from parent

    const branchImage = ({store_logo}) => {
        return (
            <div>
                <div className="image-wrapper">
                    <img src={store_logo} alt="Branch" />
                </div>
            </div>
        );
    };

    const branchActions = branch => {
        async function handleDeleteStore() {
            const res = await manageStores.deleteStore(branch._id);
            console.log(res.message);
            Toast({type: "success", message: res.message});
            if (onStoreUpdated) {
                onStoreUpdated();
            }
        }
        return (
            <>
                <div className="action-btns">
                    <ModalContainer
                        width={600}
                        title="Store Preview"
                        btnComponent={({onClick}) => (
                            <button onClick={onClick} className="eye-btn">
                                <IoEyeOutline color="rgba(28, 28, 28, 1)" />
                            </button>
                        )}
                        content={({onClose}) => <StorePreview store={branch} onClose={onClose} />}
                    />
                    {hasPermission("manage-stores.edit-store") && (
                        <ModalContainer
                            width={600}
                            title="Edit Branch"
                            btnComponent={({onClick}) => (
                                <button onClick={onClick} className="edit-btn">
                                    <FaRegEdit />
                                </button>
                            )}
                            content={({onClose}) => <AddNewBranch 
                                editBranch={branch} 
                                onClose={onClose}
                                onStoreCreated={onStoreUpdated}
                            />}
                        />
                    )}
                    {hasPermission("manage-stores.delete-store") && (
                        <ModalContainer
                            width={450}
                            noBorder
                            // refetch={refetch}
                            btnComponent={({onClick}) => (
                                <button className="delete-btn" onClick={onClick}>
                                    <MdDelete />
                                </button>
                            )}
                            content={({onClose}) => (
                                <DeleteModal
                                    title="Are you sure you want to Delete this Branch?"
                                    successTitle="Branch Deleted Successfully!"
                                    onClose={onClose}
                                    onSubmit={handleDeleteStore}
                                />
                            )}
                        />
                    )}
                </div>
            </>
        );
    };
    const columnNames = ["#", "Store Image", "Store Name", "Store Address", "Actions"];
    const {rowsData, totalCount} = useMemo(() => {
        return {
            rowsData: stores_data?.stores?.map((branch, index) => [
                index + 1,
                branchImage({store_logo: branch?.store_logo}),
                branch?.name ? branch?.name : "-------",
                branch?.address?.street_address ? branch?.address.street_address : "--------",
                branchActions(branch),
            ]),
            totalCount: stores_data?.totalItems,
        };
    }, [stores_data]);

    return (
        <>
            <ManageBranchesWrapper>
                <TableLayout
                    onChangeFilters={filters => {
                        setSearchQuery(_ => ({
                            ..._,
                            ...filters,
                        }));
                    }}
                    currentPage={searchQuery?.page}
                    pageSize={searchQuery?.itemsPerPage}
                    totalCount={totalCount}
                    setSearchText={setSearchQuery}
                    // noPagination
                >
                    <Table rowsData={rowsData} loading={stores_loading} columnNames={columnNames} noPadding />
                </TableLayout>
            </ManageBranchesWrapper>
        </>
    );
};

export default ManageBranches;
